import request from '@/utils/httpRequest'

// 首页-产品中心
export function ApiWebIndexProductList () {
  return request({
    url: request.adornUrl('/web/index/product/list'),
    method: 'get',
    params: request.adornParams()
  })
}

// 首页-产品中心-了解更多、产品中心-产品详情
export function ApiWebIndexProductInfo (id) {
  return request({
    url: request.adornUrl('/web/product/info/' + id),
    method: 'get',
    params: request.adornParams()
  })
}

//  首页-产品中心-方案详情
export function ApiWebIndexProductProjectInfo (id) {
  return request({
    url: request.adornUrl('/web/index/product/project/info/' + id),
    method: 'get',
    params: request.adornParams()
  })
}

// 产品中心
export function ApiWebProjectIndex () {
  return request({
    url: request.adornUrl(`/web/product/index`),
    method: 'get',
    params: request.adornParams()
  })
}

// 产品中心-产品详情
export function ApiWebProductInfo (data) {
  return request({
    url: request.adornUrl(`/web/product/info`),
    method: 'post',
    data: request.adornData(data)
  })
}

// 产品中心-产品和方案的背景图
export function ApiWebProjectBackground (data) {
  return request({
    url: request.adornUrl(`/web/product/background`),
    method: 'post',
    data: request.adornData(data)
  })
}


// 返回所有产品数据的列表(新增）

export function ApiWebProductList () {
  return request({
    url: request.adornUrl(`/web/product/list`),
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/product.js